import { authApi } from 'api';

/**
 * Get all visitor members (family-grouped) and their athletes in a club.
 * @param {string} clubId - The club ID
 * @returns {Promise} - The response from the API
 */
export const getVisitorMembers = async (clubId) => {
  try {
    const response = await authApi.get(
      `/Visitors/${clubId}/visitor-members-profiles`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

/**
 * Get all visitor athletes in a club.
 * @param {string} clubId - The club ID
 * @returns {Promise} - The response from the API
 */
export const getVisitorAthletes = async (clubId) => {
  try {
    const response = await authApi.get(`/Visitors/visitor-athletes/${clubId}`);
    return response;
  } catch (err) {
    throw err;
  }
};
